export default "__VITE_ASSET__DFOqHJru__"